import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Modal, Row, Table } from "reactstrap";
import { Btn, P } from "../../AbstractElements";
import axios from "axios";
import { formatMontant, URL_API } from "../../utils/helper/helpers";
import { toast } from "react-toastify";
import { Messages } from '../Constant';
import { formatPrice } from "./helpers";
import { useMaterielPriceForLaffrage } from "../../Pages/BonDeCommande/apiBon";
import { Link, useNavigate } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useAppDispatch, useAppSelector } from '../../ReduxToolkit/Hooks';
import { clearCart } from "../../ReduxToolkit/Reducers/CartSlice";


const RepousserPaiement = ({ isOpen, paiement_id, versement_id, toggle }: { isOpen: boolean; paiement_id: number; versement_id: number; toggle: () => void; }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    const [data, setData] = useState({
        num_paiement: '',
        date_paiement: '',
        montant: '',
        id_paiement: '',
        id_versement: '',
    });

    const [justificatif, setJustificatif] = useState<File | null>(null);
    const [erreur, setErreur] = useState({
        num_paiement: '',
        date_paiement: '',
        montant: '',
        justificatif: '',
        id_paiement: '',
        id_versement: '',
    });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setJustificatif(event.target.files[0]);
        }
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();

        // Création de l'objet FormData
        const formData = new FormData();
        formData.append("num_paiement", data.num_paiement);
        formData.append("date_paiement", data.date_paiement);
        formData.append("montant", data.montant);
        formData.append("id_paiement", String(paiement_id));
        formData.append("id_versement", String(versement_id));

        if (justificatif) {
            formData.append("justificatif", justificatif);
        }
        const Token = JSON.parse(localStorage.getItem("login")!);

        try {
            const response = await axios.post(`${URL_API}/repousser-paiement`, formData, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            closeModal()
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };

            if (err.response && err.response.data && err.response.data.message) {
                const newErrors = err.response.data.message;
                setErreur(prevErrors => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }
        }
    };

    const closeModal = () => {
        // Réinitialiser le formulaire si succès
        setData({
            num_paiement: '',
            date_paiement: '',
            montant: '',
            id_paiement: '',
            id_versement: '',
        });
        setErreur({
            num_paiement: '',
            date_paiement: '',
            montant: '',
            justificatif: '',
            id_paiement: '',
            id_versement: '',
        });
        setJustificatif(null);
        toggle();
        onSuccess();
    }

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Repousser un paiement</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row className="g-3">
                                        <Col md="12">
                                            <Label>No de paiement</Label>
                                            <Input
                                                className="form-control"
                                                name="num_paiement"
                                                type="text"
                                                placeholder="Nouveau Numéro de paiement"
                                                value={data.num_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.num_paiement && (
                                                <span className="text-danger">{erreur.num_paiement}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Nouvelle Date de Paiement</Label>
                                            <Input
                                                className="form-control"
                                                name="date_paiement"
                                                type="date"
                                                value={data.date_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.date_paiement && (
                                                <span className="text-danger">{erreur.date_paiement}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Montant à payer</Label>
                                            <Input
                                                className="form-control"
                                                name="montant"
                                                type="text"
                                                placeholder="Nouveau Montant à payer"
                                                value={data.montant}
                                                onChange={changeHandler}
                                            />
                                            {erreur.montant && (
                                                <span className="text-danger">{erreur.montant}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Justificatif</Label>
                                            <Input
                                                className="form-control"
                                                name="justificatif"
                                                type="file"
                                                onChange={handleFileChange}
                                            />
                                            {erreur.justificatif && (
                                                <span className="text-danger">{erreur.justificatif}</span>
                                            )}
                                        </Col>
                                        <Col xs="12">
                                            <Btn color="info" className="me-2" type="submit">
                                                Soumettre
                                            </Btn>
                                            <Btn color="danger" className="mx-2" onClick={() => closeModal()}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};
export default RepousserPaiement;

export const PayerVersement = ({ isOpen, montant_a_payer, versement_id, toggle }: { isOpen: boolean; montant_a_payer: number; versement_id: number; toggle: () => void; }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    const [data, setData] = useState({
        num_paiement: '',
        date_paiement: '',
        montant: montant_a_payer,
        id_paiement: '',
        id_versement: '',
    });

    const [justificatif, setJustificatif] = useState<File | null>(null);
    const [erreur, setErreur] = useState({
        num_paiement: '',
        date_paiement: '',
        montant: '',
        justificatif: '',
        id_paiement: '',
        id_versement: '',
    });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setJustificatif(event.target.files[0]);
        }
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        setData((prevState) => ({
            ...prevState,
            montant: montant_a_payer,
        }));
    }, [data.montant, montant_a_payer])

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();

        // Création de l'objet FormData
        const formData = new FormData();
        formData.append("num_paiement", data.num_paiement);
        formData.append("date_paiement", data.date_paiement);
        formData.append('montant', String(data.montant))
        formData.append("id_versement", String(versement_id));

        if (justificatif) {
            formData.append("justificatif", justificatif);
        }

        axios.post(`${URL_API}/valider-paiement`, formData, {
            headers: {
                Authorization: `Bearer ${Token}`,
                'Content-Type': 'multipart/form-data',
            }
        }).then(response => {

            if (response.data.success) {

                toast.success(response.data.success)
                setData({
                    num_paiement: '',
                    date_paiement: '',
                    montant: montant_a_payer,
                    id_paiement: '',
                    id_versement: '',
                });
                setErreur({
                    num_paiement: '',
                    date_paiement: '',
                    montant: '',
                    justificatif: '',
                    id_paiement: '',
                    id_versement: '',
                });
                setJustificatif(null);
                toggle();
                onSuccess();
            }

        }).catch(error => {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };
            console.log(err.response);
            if (err.response && err.response.data && err.response.data.message) {
                toast.info('Erreur de validation des données')
                const newErrors = err.response.data.message;
                setErreur(prevErrors => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }

        })
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Payer L'Achat {versement_id}</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row className="g-3">
                                        <Col md="12">
                                            <Label>No de paiement</Label>
                                            <Input
                                                className="form-control"
                                                name="num_paiement"
                                                type="text"
                                                placeholder="Nouveau Numéro de paiement"
                                                value={data.num_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.num_paiement && (
                                                <span className="text-danger">{erreur.num_paiement}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Nouvelle Date de Paiement</Label>
                                            <Input
                                                className="form-control"
                                                name="date_paiement"
                                                type="date"
                                                value={data.date_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.date_paiement && (
                                                <span className="text-danger">{erreur.date_paiement}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Montant à payer</Label>
                                            <Input
                                                className="form-control"
                                                name="montant"
                                                type="text"
                                                placeholder="Nouveau Montant à payer"
                                                value={formatPrice(data.montant)}
                                                onChange={changeHandler} disabled
                                            />
                                            {erreur.montant && (
                                                <span className="text-danger">{erreur.montant}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Justificatif</Label>
                                            <Input
                                                className="form-control"
                                                name="justificatif"
                                                type="file"
                                                onChange={handleFileChange}
                                            />
                                            {erreur.justificatif && (
                                                <span className="text-danger">{erreur.justificatif}</span>
                                            )}
                                        </Col>
                                        <Col xs="12">
                                            <Btn color="info" className="me-2" type="submit">
                                                Soumettre
                                            </Btn>
                                            <Btn color="danger" className="mx-2" onClick={toggle}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};

export const AddNumBons = ({ isOpen, versement_id, fournisseur_id, four_type, toggle, }: { isOpen: boolean; versement_id: number | null; fournisseur_id: number | null; four_type: string; toggle: () => void; }, onSuccess: () => void) => {
    const [data, setData] = useState({
        num_bons: [] as string[], // Tableau pour stocker plusieurs num_bons
    });
    const Token = JSON.parse(localStorage.getItem("login")!);
    const [currentNumBon, setCurrentNumBon] = useState(""); // État pour le champ d'entrée temporaire
    const [erreur, setErreur] = useState({
        num_bons: "",
    });

    // Gestion du champ temporaire pour ajouter un nouveau bon
    const handleCurrentNumBonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentNumBon(e.target.value);
    };

    // Ajout d'un nouveau bon dans la liste
    const addNumBon = () => {
        if (currentNumBon.trim() !== "") {
            if (!data.num_bons.includes(currentNumBon.trim())) {
                setData((prevState) => ({
                    ...prevState,
                    num_bons: [...prevState.num_bons, currentNumBon.trim()],
                }));
                setCurrentNumBon(""); // Réinitialiser le champ temporaire
            } else {
                toast.info("Le numéro de bon existe déjà.");
            }
        } else {
            toast.error("Le numéro de bon ne peut pas être vide.");
        }
    };

    // Suppression d'un bon de la liste
    const removeNumBon = (index: number) => {
        setData((prevState) => ({
            ...prevState,
            num_bons: prevState.num_bons.filter((_, i) => i !== index),
        }));
    };

    // Gestion de la soumission du formulaire
    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();

        // Création de l'objet FormData
        const formData = new FormData();
        data.num_bons.forEach((bon, index) => {
            formData.append(`num_bons[${index}]`, bon); // Envoi des bons sous forme de tableau
        });
        formData.append("id_versement", String(versement_id));
        formData.append("id_fournisseur", String(fournisseur_id));
        formData.append("four_type", String(four_type));

        try {
            const response = await axios.post(`${URL_API}/add-num-bons`, formData, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            toast.info(response.data.message)

            setData({
                num_bons: [],
            });
            setErreur({
                num_bons: "",
            });
            toggle();
            onSuccess();
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };
            if (err.response && err.response.data && err.response.data.message) {
                toast.info("Erreur de validation des données");
                setErreur({ num_bons: err.response.data.message.num_bons || "" });
            }
        }
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Nouveau Numéro de Bons</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row className="g-3">
                                        <Col md="9">
                                            <Input
                                                className="form-control"
                                                name="currentNumBon"
                                                type="text"
                                                placeholder="Ajouter un numéro de bon"
                                                value={currentNumBon}
                                                onChange={handleCurrentNumBonChange}
                                            />
                                        </Col>
                                        <Col md="2" className="text-center my-3">
                                            <Btn color="light-dark" className="for-light" type="button" onClick={addNumBon}>
                                                Ajouter
                                            </Btn>
                                            <Btn color="light-light" className="for-light" type="button" onClick={addNumBon}>
                                                Ajouter
                                            </Btn>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12">
                                            <Table>
                                                <thead>
                                                    <th>Numéro</th>
                                                    <th className="text-end">Actions</th>
                                                </thead>
                                                <tbody>
                                                    {data.num_bons.map((bon, index) => (
                                                        <tr key={index}>
                                                            <td>{bon}{" "}</td>
                                                            <td className="text-end">
                                                                <Btn color="light-danger" size="xs" type="button" onClick={() => removeNumBon(index)} >
                                                                    Supprimer
                                                                </Btn>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            {erreur.num_bons && (
                                                <span className="text-danger">{erreur.num_bons}</span>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs="12 mt-2">
                                            <Btn color="info" className="me-2" type="submit">
                                                Soumettre
                                            </Btn>
                                            <Btn color="danger" onClick={toggle}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};

export const UpdateStatusBons = ({ isOpen, bons_id, toggle, }: { isOpen: boolean; bons_id: number | null; toggle: () => void; }, onSuccess: () => void) => {
    const [data, setData] = useState({
        status: '',
        id_bons: '',
    });

    const Token = JSON.parse(localStorage.getItem("login")!);
    const [erreur, setErreur] = useState({
        status: '',
        id_bons: '',
    });

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('status', data.status);
        formData.append('bons_id', String(bons_id));

        try {
            const response = await axios.post(`${URL_API}/bon/changeStatus`, formData, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });

            // if (response.data.status == 200) {
            setData({
                status: '',
                id_bons: '',
            });
            setErreur({
                status: '',
                id_bons: '',
            });
            toast.info(response.data.message)
            toggle();
            onSuccess();
            // }
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };

            if (err.response?.data?.message) {
                toast.info('Erreur de validation des données');
                const newErrors = err.response.data.message;
                setErreur((prevErrors) => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }
        }
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Changer de status</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row className="g-3">
                                        <Col md="12">
                                            <Label>Nouvelle Status</Label>
                                            <Input
                                                className="form-control"
                                                name="status"
                                                type="text"
                                                placeholder="Nouveau status à payer"
                                                value={data.status}
                                                onChange={changeHandler}
                                            />
                                            {erreur.status && (
                                                <span className="text-danger">{erreur.status}</span>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs="12 mt-2">
                                            <Btn color="info" className="me-2" type="submit">
                                                Soumettre
                                            </Btn>
                                            <Btn color="danger" onClick={toggle}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};
interface clientsInterface {
    [key: string]: any;
}
export const AddClient = ({ isOpen, bons_id, toggle, }: { isOpen: boolean; bons_id: number | null; toggle: () => void; }, onSuccess: () => void) => {
    const [data, setData] = useState({
        nom: '',
        vente: '',
        transport: '',
        id_bons: '',
    });


    const Token = JSON.parse(localStorage.getItem("login")!);
    const [clients, setClients] = useState<clientsInterface[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const [erreur, setErreur] = useState({
        client: '',
        vente: '',
        transport: '',
        id_bons: '',
    });
    const navigate = useNavigate()

    useEffect(() => {
        const fetchUsers = async () => {
            axios.get(`${URL_API}/clients/get`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status == 200) {
                    setClients(response.data.clients);
                }

            }).catch(error => {
                if (error.status === 400) {
                    toast.info(error.response.data.message);
                }

                if (error.status === 500) {
                    toast.warning(error.response.data.message);
                }
            })
        };

        fetchUsers();

    },[]);

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        
        if(value === 'ajouter'){
            navigate('/clients')
        }else{
            const formattedValue = name === "vente" || name == 'transport' ? formatMontant(value) : value;
            setData((prevState) => ({
                ...prevState,
                [name]: formattedValue,
            }));
        }
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formData = new FormData();
        formData.append('nouveau_client', data.nom);
        formData.append('bons_id', String(bons_id));
        formData.append('vente', data.vente);
        formData.append('transport', data.transport);

        try {
            const response = await axios.post(`${URL_API}/bon/add-client`, formData, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            // if (response.data.status == 200) {
            setData({
                nom: '',
                vente: '',
                transport: '',
                id_bons: '',
            });
            setErreur({
                client: '',
                vente: '',
                transport: '',
                id_bons: '',
            });
            toast.success(response.data.message)
            toggle();
            onSuccess();
            // }
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };

            if (err.response?.data?.message) {
                toast.info('Erreur de validation des données');
                const newErrors = err.response.data.message;
                setErreur((prevErrors) => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }
        }
        setIsSubmitting(false);
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Selectionner un client</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row className="g-3">
                                        
                                        <Col sm='12'>
                                            <Input
                                                className="form-control"
                                                name="nom"
                                                type="select"
                                                value={data.nom}
                                                onChange={changeHandler}
                                                >
                                                <option value=''>Selectionner ici</option>
                                                {clients.map((item, index) => (
                                                    <option key={index} value={item.id}>{item.name}</option>
                                                ))}
                                                <option value='ajouter'>AJOUTER UN NOUVEAU CLIENTS</option>
                                            </Input>
                                            {erreur.client && (
                                                <span className="text-danger">{erreur.client}</span>
                                            )}
                                        </Col>
                                        <Col sm='12' className="text-center">
                                            <Link to='/clients' className="fw-bold fs-6"> <i className="fa fa-hand-o-right"></i> Ajouter un nouveau client ici <i className="fa fa-hand-o-left"></i> </Link>
                                        </Col>
                                        <Col sm='12'>
                                            <Label>Montant de vente</Label>
                                            <Input
                                                className="form-control"
                                                name="vente"
                                                type="text"
                                                value={data.vente}
                                                onChange={changeHandler}
                                                placeholder="Montant de vente / tonne"
                                                >
                                            </Input>
                                            {erreur.vente && (
                                                <span className="text-danger">{erreur.vente}</span>
                                            )}
                                        </Col>
                                        <Col sm='12'>
                                            <Label>Frais de livraison ou transport</Label>
                                            <Input
                                                className="form-control"
                                                name="transport"
                                                type="text"
                                                value={data.transport}
                                                onChange={changeHandler}
                                                placeholder="0 GNF"
                                                >
                                            </Input>
                                            {erreur.transport && (
                                                <span className="text-danger">{erreur.transport}</span>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs="12 mt-2 d-flex">
                                            <Btn color="info" className="me-2 w-100" disabled={isSubmitting} type="submit">
                                                { isSubmitting ? "En cours..." : "Envoyer" }
                                            </Btn>
                                            <Btn color="danger" className="w-100" onClick={toggle}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};

export const PaiementClients = ({ isOpen, montant, client_id, toggle }: { isOpen: boolean; montant: number; client_id: number; toggle: () => void; }, onSuccess: () => void) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const [data, setData] = useState({
        num_paiement: '',
        date_paiement: '',
        montant: '',
        mode_payment: '',
    });

    const [justificatif, setJustificatif] = useState<File | null>(null);
    const [erreur, setErreur] = useState({
        num_paiement: '',
        date_paiement: '',
        montant: '',
        mode_payment: '',
        justificatif: '',
    });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setJustificatif(event.target.files[0]);
        }
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        
        // Vérification si `name` est `montant` pour effectuer la validation uniquement sur ce champ
        if (name === "montant") {
            const firstValue = value.replace(/[^\d]/g, '');
            const numericValue = parseInt(firstValue);
            if (!isNaN(numericValue) && numericValue > montant) {
                toast.warning("Le montant saisi est trop élevé");
            }
        }
        const formattedValue = name === "montant" ? formatMontant(value) : value;
    
        // Mise à jour de l'état
        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue,
        }));
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        // Création de l'objet FormData
        const formData = new FormData();
        formData.append("num_paiement", data.num_paiement);
        formData.append("id_client", String(client_id));
        formData.append("date_paiement", data.date_paiement);
        formData.append("montant", data.montant);
        formData.append("mode_payment", data.mode_payment);

        if (justificatif) {
            formData.append("justificatif", justificatif);
        }
        const Token = JSON.parse(localStorage.getItem("login")!);

        try {
            const response = await axios.post(`${URL_API}/paiement-client`, formData, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            closeModal()
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };

            if (err.response && err.response.data && err.response.data.message) {
                const newErrors = err.response.data.message;
                setErreur(prevErrors => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }
        }

        setIsSubmitting(false);
    };

    const closeModal = () => {
        setData({
            num_paiement: '',
            date_paiement: '',
            montant: '',
            mode_payment: '',
        });
        setErreur({
            num_paiement: '',
            date_paiement: '',
            montant: '',
            mode_payment: '',
            justificatif: '',
        });
        setJustificatif(null);
        toggle();
        onSuccess();
    }


    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Effectuer un paiement Clients</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row>
                                        <Col md="12">
                                            <Label>No de paiement</Label>
                                            <Input
                                                className="form-control"
                                                name="num_paiement"
                                                type="text"
                                                placeholder="Nouveau Numéro de paiement"
                                                value={data.num_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.num_paiement && (
                                                <span className="text-danger">{erreur.num_paiement}</span>
                                            )}
                                        </Col>
                                        <Col sm="12">
                                            <FormGroup>
                                                <Label>Mode de paiement<span className="text-danger">*</span></Label>
                                                <Input
                                                    placeholder="Entrer le type"
                                                    name="mode_payment"
                                                    value={data.mode_payment || ''}
                                                    onChange={changeHandler}
                                                    type="select"
                                                    className="form-control"
                                                >
                                                    <option value=''>Sélectionner...</option>
                                                    <option value='Chèque'>Chèque</option>
                                                    <option value='Espèce'>Espece ou Liquide</option>
                                                    <option value='Virement Bancaire'>Virement Bancaire</option>
                                                    <option value='Aucun'>Aucun</option>
                                                </Input>
                                                {erreur.mode_payment && (
                                                    <span className="text-danger">{erreur.mode_payment}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <Label>Date de Paiement<span className="text-danger">*</span></Label>
                                            <Input
                                                className="form-control"
                                                name="date_paiement"
                                                type="date"
                                                value={data.date_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.date_paiement && (
                                                <span className="text-danger">{erreur.date_paiement}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Montant payer</Label>
                                            <Input
                                                className="form-control"
                                                name="montant"
                                                type="text"
                                                placeholder="Nouveau Montant à payer"
                                                value={data.montant}
                                                onChange={changeHandler}
                                            />
                                            {erreur.montant && (
                                                <span className="text-danger">{erreur.montant}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Justificatif</Label>
                                            <Input
                                                className="form-control"
                                                name="justificatif"
                                                type="file"
                                                onChange={handleFileChange}
                                            />
                                            {erreur.justificatif && (
                                                <span className="text-danger">{erreur.justificatif}</span>
                                            )}
                                        </Col>
                                        <Col xs="12" className="d-flex mt-3">
                                            <Btn color="info" className="me-2 w-100" type="submit"  disabled={isSubmitting}>
                                                {isSubmitting ? "En cours..." : "Envoyer"}
                                            </Btn>
                                            <Btn color="danger" className="ms-2 w-100" onClick={() => closeModal()}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                        
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};

export const AddEtsTransitaire = ({ isOpen, toggle, }: { isOpen: boolean; toggle: () => void; }, onSuccess: () => void) => {
    const [data, setData] = useState({
        nom: '',
        code: '',
        telephone: '',
        adresse: '',
    });

    const Token = JSON.parse(localStorage.getItem("login")!);
    const [erreur, setErreur] = useState({
        nom: '',
        code: '',
        telephone: '',
        adresse: '',
    });

    const [loader, setLoader] = useState(false)

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();

        setLoader(true);
        const formData = new FormData();
        formData.append('nom', data.nom);
        formData.append('code', data.code);
        formData.append('telephone', data.telephone);
        formData.append('adresse', data.adresse);

        try {
            const response = await axios.post(`${URL_API}/entreprise/create`, formData, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });

            // if (response.data.status == 200) {
            setData({
                nom: '',
                code: '',
                telephone: '',
                adresse: '',
            });
            setErreur({
                nom: '',
                code: '',
                telephone: '',
                adresse: '',
            });
            toast.info(response.data.message)
            toggle();
            setLoader(false);
            onSuccess();
            // }
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };
            setLoader(false);

            if (err.response?.data?.message) {
                toast.info('Erreur de validation des données');
                const newErrors = err.response.data.message;
                setErreur((prevErrors) => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }
        }
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Ajouter Un Etablissement Transitaire</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row className="g-3">
                                        <Col md="12">
                                            <Label>Nom<span className="text-danger">*</span></Label>
                                            <Input
                                                className="form-control"
                                                name="nom"
                                                type="text"
                                                placeholder="Entrer le nom"
                                                value={data.nom}
                                                onChange={changeHandler}
                                            />
                                            {erreur.nom && (
                                                <span className="text-danger">{erreur.nom}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Code<span className="text-danger">*</span></Label>
                                            <Input
                                                className="form-control"
                                                name="code"
                                                type="text"
                                                placeholder="Entrer le code"
                                                value={data.code}
                                                onChange={changeHandler}
                                            />
                                            {erreur.code && (
                                                <span className="text-danger">{erreur.code}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Téléphone<span className="text-danger">*</span></Label>
                                            <Input
                                                className="form-control"
                                                name="telephone"
                                                type="text"
                                                placeholder="Entrer le téléphone"
                                                value={data.telephone}
                                                onChange={changeHandler}
                                            />
                                            {erreur.telephone && (
                                                <span className="text-danger">{erreur.telephone}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Adresse<span className="text-danger">*</span></Label>
                                            <Input
                                                className="form-control"
                                                name="adresse"
                                                type="text"
                                                placeholder="Entrer le adresse"
                                                value={data.adresse}
                                                onChange={changeHandler}
                                            />
                                            {erreur.adresse && (
                                                <span className="text-danger">{erreur.adresse}</span>
                                            )}
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs="12 mt-2 d-flex">
                                            <Btn color="info" className="me-2 w-100" type="submit">
                                                { loader == false ? 'Soumettre' : <i className="fa fa-spinner"></i>}
                                            </Btn>
                                            <Btn color="danger" className="w-100" onClick={toggle}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};

export const PaiementTransitaire = ({ isOpen, montant, versement_id, toggle }: { isOpen: boolean; montant: number; versement_id: number; toggle: () => void;  }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    const [selectedMateriel, setSelectedMateriel] = useState<string>("");
    const [materiel, setMateriel] = useState<string>("");
    const [price, setPrice] = useState<number>(0);
    const [quantityDispo, setQuantityDispo] = useState<number>(0);
    const [quantity, setQuantity] = useState<number>(0);
    const materielPrice = useMaterielPriceForLaffrage()
    
    const [data, setData] = useState({
        num_paiement: '',
        date_paiement: '',
        nom_complet: '',
        montant: '',
        mode_payment: '',
        id_versement: '',
        materiel: [] as { materiel: string; price: number; quantity: number }[],
    });

    const [justificatif, setJustificatif] = useState<File | null>(null);
    const [erreur, setErreur] = useState({
        num_paiement: '',
        date_paiement: '',
        nom_complet: '',
        montant: '',
        mode_payment: '',
        materiel: '',
        justificatif: '',
        id_versement: '',
    });

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            setJustificatif(event.target.files[0]);
        }
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
    
        // Vérification si `name` est `montant` pour effectuer la validation uniquement sur ce champ
        if (name === "montant") {
            const numericValue = parseInt(value); // Convertir la valeur en nombre
            if (!isNaN(numericValue) && numericValue > montant) {
                toast.info("Le montant saisi est trop élevé");
            }
        }
    
        // Mise à jour de l'état
        setData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();

        // Création de l'objet FormData
        const formData = new FormData();
        formData.append("num_paiement", data.num_paiement);
        formData.append("date_paiement", data.date_paiement);
        formData.append("montant", data.montant);
        formData.append("mode_payment", data.mode_payment);
        formData.append("receveur", data.nom_complet);
        formData.append("materiel", JSON.stringify(data.materiel));
        formData.append("id_versement", String(versement_id));
        formData.append("selected_option", selectedOption);

        if (justificatif) {
            formData.append("justificatif", justificatif);
        }
        const Token = JSON.parse(localStorage.getItem("login")!);

        try {
            const response = await axios.post(`${URL_API}/paiement-transit`, formData, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                    'Content-Type': 'multipart/form-data',
                },
            });
            closeModal()
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };
            if (err.response && err.response.data && err.response.data.message) {
                const newErrors = err.response.data.message;
                setErreur(prevErrors => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }
        }
    };

    const closeModal = () => {
        setData({
            num_paiement: '',
            date_paiement: '',
            montant: '',
            mode_payment: '',
            nom_complet: '',
            materiel: [] as { materiel: string; price: number; quantity: number }[],
            id_versement: '',
        });
        setErreur({
            num_paiement: '',
            date_paiement: '',
            montant: '',
            mode_payment: '',
            nom_complet: '',
            materiel: '',
            justificatif: '',
            id_versement: '',
        });
        setJustificatif(null);
        toggle();
        onSuccess();
    }
    const [selectedOption, setSelectedOption] = useState<string>('Option 1'); // État pour la sélection

    const handleChangeSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(event.target.value); // Met à jour l'état avec la valeur sélectionnée
        setData({
            num_paiement: '',
            date_paiement: data.date_paiement,
            nom_complet: data.nom_complet,
            montant: '',
            mode_payment: data.mode_payment,
            materiel: [] as { materiel: string; price: number; quantity: number }[],
            id_versement: '',
        });
        setErreur({
            num_paiement: '',
            date_paiement: '',
            montant: '',
            nom_complet: '',
            materiel: '',
            mode_payment: '',
            justificatif: '',
            id_versement: '',
        });
    };

    const handleMaterielChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selected = e.target.value;
        setMateriel(selected)
        const selectedData = materielPrice.find(item => parseInt(item.id) === parseInt(selected));

        if (selectedData) {
            setSelectedMateriel(selectedData.materiel);
            setPrice(selectedData.montant);
            setQuantityDispo(selectedData.qt_update)
        } else {
            setPrice(0);
            setQuantityDispo(0);
        }
    };

    const handleQuantityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setQuantity(Number(e.target.value));
    };

    // Ajouter une ligne au tableau des matériaux
    const addToTable = () => {
        if (selectedMateriel && price > 0 && quantity > 0) {
            if (quantity > quantityDispo) {
                return toast.info('La Quantite sortie est trop elevé')
            }
            // Vérifier si l'élément existe déjà
            const exists = data.materiel.some((item) => item.materiel === selectedMateriel);
            if (!exists) {
                setData((prevData) => ({
                    ...prevData,
                    materiel: [
                        ...prevData.materiel,
                        { materiel: selectedMateriel, price, quantity },
                    ],
                }));
                setSelectedMateriel(""); // Réinitialise la sélection
                setPrice(0);
                setQuantity(0);
            } else {
                toast.info("Cet élément est déjà ajouté au tableau.");
            }
        } else {
            toast.info("Veuillez completer tous les champs !!");
        }
    };

    // Supprimer une ligne du tableau des matériaux
    const removeFromTable = (index: number) => {
        setData((prevData) => ({
            ...prevData,
            materiel: prevData.materiel.filter((_, i) => i !== index),
        }));
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Effectuer un paiement transitaire</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row>
                                        <Col md="12">
                                            <Label>Nom Complet<span className="text-danger">*</span></Label>
                                            <Input
                                                className="form-control"
                                                name="nom_complet"
                                                type="text"
                                                placeholder="Nom Complet"
                                                value={data.nom_complet}
                                                onChange={changeHandler}
                                            />
                                            {erreur.nom_complet && (
                                                <span className="text-danger">{erreur.nom_complet}</span>
                                            )}
                                        </Col>
                                        <Col sm="12">
                                            <FormGroup>
                                                <Label>Mode de paiement<span className="text-danger">*</span></Label>
                                                <Input
                                                    placeholder="Entrer le type"
                                                    name="mode_payment"
                                                    value={data.mode_payment || ''}
                                                    onChange={changeHandler}
                                                    type="select"
                                                    className="form-control"
                                                >
                                                    <option value=''>Sélectionner...</option>
                                                    <option value='Chèque'>Chèque</option>
                                                    <option value='Espèce'>Espece ou Liquide</option>
                                                    <option value='Virement Bancaire'>Virement Bancaire</option>
                                                    <option value='Aucun'>Aucun</option>
                                                </Input>
                                                {erreur.mode_payment && (
                                                    <span className="text-danger">{erreur.mode_payment}</span>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <Label>Date de Paiement<span className="text-danger">*</span></Label>
                                            <Input
                                                className="form-control"
                                                name="date_paiement"
                                                type="date"
                                                value={data.date_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.date_paiement && (
                                                <span className="text-danger">{erreur.date_paiement}</span>
                                            )}
                                        </Col>
                                        <Col sm="12">
                                            <div className="text-center">
                                                <h5>Choisissez une option de paiement<span className="text-danger">*</span></h5>
                                                <label className="mt-2 form-check-label mx-2">
                                                <input
                                                    type="radio"
                                                    value="Option 1"
                                                    className="radio-border-primary radio-primary form-check-input"
                                                    checked={selectedOption === 'Option 1'}
                                                    onChange={handleChangeSelection}
                                                />
                                                    Chèque ou Espece
                                                </label>

                                                <label className="mt-2 form-check-label mx-2">
                                                <input
                                                    type="radio"
                                                    value="Option 2"
                                                    className="radio-border-primary radio-primary form-check-input"
                                                    checked={selectedOption === 'Option 2'}
                                                    onChange={handleChangeSelection}
                                                />
                                                Bon ou Tonnes
                                                </label>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <Row> */}
                                        {
                                            selectedOption === 'Option 1' ? (
                                                <Row>
                                                    <Col md="12">
                                                        <Label>No de paiement</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="num_paiement"
                                                            type="text"
                                                            placeholder="Nouveau Numéro de paiement"
                                                            value={data.num_paiement}
                                                            onChange={changeHandler}
                                                        />
                                                        {erreur.num_paiement && (
                                                            <span className="text-danger">{erreur.num_paiement}</span>
                                                        )}
                                                    </Col>
                                                    <Col md="12">
                                                        <Label>Montant à payer</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="montant"
                                                            type="text"
                                                            placeholder="Nouveau Montant à payer"
                                                            value={data.montant}
                                                            onChange={changeHandler}
                                                        />
                                                        {erreur.montant && (
                                                            <span className="text-danger">{erreur.montant}</span>
                                                        )}
                                                    </Col>
                                                    <Col md="12">
                                                        <Label>Justificatif</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="justificatif"
                                                            type="file"
                                                            onChange={handleFileChange}
                                                        />
                                                        {erreur.justificatif && (
                                                            <span className="text-danger">{erreur.justificatif}</span>
                                                        )}
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Row>
                                                    {
                                                        data.materiel.length < 1 ? (
                                                            <>
                                                                <Col sm={12}>
                                                                    <Label>Materiel</Label>
                                                                    <Input
                                                                        type="select"
                                                                        value={materiel}
                                                                        onChange={handleMaterielChange}
                                                                        className="form-control"
                                                                    >
                                                                        <option value="">Sélectionner...</option>
                                                                        {materielPrice.length > 0 &&
                                                                            materielPrice.map((item) => {
                                                                                if (item.id_versement == versement_id) {
                                                                                    return (
                                                                                        <option key={item.id} value={item.id}>
                                                                                            {item.materiel}
                                                                                        </option>
                                                                                    );
                                                                                }
                                                                                return null;
                                                                            })}
                                                                    </Input>
                                                                </Col>
                                                                <Col sm={12}>
                                                                    <Label>Prix Unitaire</Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={formatPrice(price)}
                                                                        disabled
                                                                        placeholder="Prix"
                                                                    />
                                                                </Col>
                                                                <Col sm={12}>
                                                                    <Label>Qte Disponible</Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={quantityDispo.toLocaleString("gn-GN") + " T"}
                                                                        disabled
                                                                        placeholder="Prix"
                                                                    />
                                                                </Col>
                                                                <Col sm={12}>
                                                                    <FormGroup>
                                                                        <Label>Quantité a sortir</Label>
                                                                        <Input
                                                                            placeholder="Entrer la quantité en tonne"
                                                                            name="quantity"
                                                                            value={quantity}
                                                                            onChange={handleQuantityChange}
                                                                            type="number"
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm={12}>
                                                                    <Button color="light-dark" onClick={addToTable} className="w-100 for-light">
                                                                        Ajouter
                                                                    </Button>
                                                                    <Button color="light-light" onClick={addToTable} className="w-100 for-dark">
                                                                        Ajouter
                                                                    </Button>
                                                                </Col>
                                                            </>
                                                        ) : (
                                                            <Col sm={12}>
                                                                <Table className="mb-4" responsive striped>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Matériel</th>
                                                                            <th>Prix</th>
                                                                            <th>Quantité</th>
                                                                            <th>Montant</th>
                                                                            <th>Actions</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {data.materiel.map((row, index) => (
                                                                            <tr key={index}>
                                                                                <td>{row.materiel}</td>
                                                                                <td>{row.price.toLocaleString()} GNF</td>
                                                                                <td>{row.quantity}</td>
                                                                                <td>{formatPrice(row.quantity * row.price)}</td>
                                                                                <td>
                                                                                    <Btn color="light-danger" size="xs" type="button" onClick={() => removeFromTable(index)}>
                                                                                        Supprimer
                                                                                    </Btn>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            </Col>
                                                        )
                                                    }
                                                    {erreur.materiel && (
                                                            <span className="text-danger">{erreur.materiel}</span>
                                                        )}
                                                </Row>
                                            )
                                        }
                                        <Col xs="12" className="d-flex mt-3">
                                            <Btn color="info" className="me-2 w-100" type="submit">
                                                Soumettre
                                            </Btn>
                                            <Btn color="danger" className="ms-2 w-100" onClick={() => closeModal()}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    {/* </Row> */}
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};

// export const EditerCaisse = ({isOpen, item, toggle}: {isOpen: boolean; item: {}, toggle: () => void}, onSuccess: () => void) => {
export const EditerCaisse = ({ isOpen, item, toggle, onSuccess, onCancel}: {isOpen: boolean; item: any; toggle: () => void; onSuccess: () => void; onCancel?: () => void; }) => {
    const [refresh, setRefresh] = useState(false)
    const [show, setShow] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const Token = JSON.parse(localStorage.getItem("login")!);

    const [data, setData] = useState({
        montant: 0,
        type: '',
        description: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        montant: '',
        type: '',
        description: '',
        id: null
    });

    useEffect(() => {
        if (item) {
            clearDataForm();
            setData({
            montant: item.montant || 0,
            type: item.type || '',
            description: item.descriptions || '',
            id: item.id || null,
            });
        }
    },[item]);

    const handleCancel = () => {
        toggle();
        onCancel?.();
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        
        const formattedValue = name === "montant" ? formatMontant(value) : value;

        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    const handleCKEditorChange = (event: any, editor: any) => {
        const data = editor.getData();
        setData((prevState) => ({
            ...prevState,
            description: data
        }));
    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        const url = `${URL_API}/caisse/update/${data.id}`

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                toast.success("Enrégistrement éffectué avec succès");
                clearDataForm();
                toggle();
                onSuccess();
            }

        }).catch(error => {
            toast.info("Oups !! Erreur de modification des données");
            if (error.response.status === 422) {
                setErreur(error.response.data.message);
            }
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }
    const clearDataForm = () => {
        setData({
            montant: 0,
            type: '',
            description: '',
            id: null
        });
        setErreur({
            montant: '',
            type: '',
            description: '',
            id: null
        });
        setShow(false);
    }

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Modification d'une <span className={`fw-bold ${data.type === 'Sortie' ? 'text-danger' : 'text-success'}`}>{data.type}</span> de la caisse </h4>
                                {/* <h4 className={` fw-bold mb-3 ${data.type === 'Sortie' ? 'text-danger' : 'text-success'}`}>{data.type} </h4> */}
                                <form onSubmit={handleSubmitData}>
                                    
                                    <div className="product-info">
                                        <div className="product-group">
                                            <Row>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Type de mouvement</Label>
                                                        <Input
                                                            name="type"
                                                            value={data.type}
                                                            onChange={changeHandler}
                                                            type="select"
                                                            className="form-control"
                                                        >
                                                            <option value="">Selectionner...</option>
                                                            <option value="Entrée">Entrée</option>
                                                            <option value="Sortie">Sortie</option>
                                                        </Input>
                                                        {erreur.type && (
                                                            <span className="text-danger">{erreur.type}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="6">
                                                    <FormGroup>
                                                        <Label>Montant</Label>
                                                        <Input
                                                            placeholder="Entrer le montant"
                                                            name="montant"
                                                            value={data.montant}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.montant && (
                                                            <span className="text-danger">{erreur.montant}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Descriptions</Label>

                                                        {show === false ? (

                                                            <>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={data.description}
                                                                    name='desc'
                                                                    onChange={handleCKEditorChange}
                                                                />
                                                                {erreur.description && (
                                                                    <span className="text-danger">{erreur.description}</span>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div className="text-dark text-center" dangerouslySetInnerHTML={{ __html: data.description }} onClick={() => setShow(!show)}></div>
                                                        )}
                                                    </FormGroup>

                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                        
                                    <Col xs="12" className="d-flex mt-3">
                                        <Btn color="info" className="me-2 w-100" type="submit">
                                            Modifier
                                        </Btn>
                                        <Btn color="danger" className="ms-2 w-100" onClick={handleCancel}>
                                            Annuler
                                        </Btn>
                                    </Col>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
}


export const EditerBonDiamond = ({ isOpen, item, num_bons, toggle, onSuccess, onCancel }: { isOpen: boolean; item: any; num_bons: string; toggle: () => void; onSuccess: () => void; onCancel?: () => void; }) => {
    const [refresh, setRefresh] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const Token = JSON.parse(localStorage.getItem("login")!);

    const [data, setData] = useState({
        id_bons: null,
        immatriculation: '',
        destination: '',
        nom_chauffeur: '',
        num_permis: '',
        telephone: '',

    });
    const [erreur, setErreur] = useState({
        id_bons: null,
        immatriculation: '',
        destination: '',
        nom_chauffeur: '',
        num_permis: '',
        telephone: '',
    });

    useEffect(() => {
        if (item) {
            clearDataForm();
            setData({
                id_bons: item.id || null,
                immatriculation: item.immatriculation || '',
                destination: item.destination || '',
                nom_chauffeur: item.nom_chauffeur || '',
                num_permis: item.num_permis || '',
                telephone: item.telephone || '',
            });
        }
    }, [item]);

    const handleCancel = () => {
        toggle();
        onCancel?.(); 
    }
    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        const formattedValue = name === "montant" ? formatMontant(value) : value;

        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        const url = `${URL_API}/bon-diamond/update`

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success && response.status === 200) {
                toast.success(response.data.message);
                clearDataForm();
                toggle();
                onSuccess();
            }

        }).catch(error => {
            console.log(error)
            toast.info("Oups !! Erreur de modification des données");
            if (error.response.status === 422) {
                setErreur(error.response.data.message);
            }
            
        });
        // setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }
    const clearDataForm = () => {
        setData({
            id_bons: null,
            immatriculation: '',
            destination: '',
            nom_chauffeur: '',
            num_permis: '',
            telephone: '',
        });
        setErreur({
            id_bons: null,
            immatriculation: '',
            destination: '',
            nom_chauffeur: '',
            num_permis: '',
            telephone: '',
        });
    }

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Modification du bon {num_bons} </h4>
                                {/* <h4 className={` fw-bold mb-3 ${data.type === 'Sortie' ? 'text-danger' : 'text-success'}`}>{data.type} </h4> */}
                                <form onSubmit={handleSubmitData}>
                                    
                                    <div className="product-info">
                                        <div className="product-group">
                                            <Row>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Nom Chauffeur <span className="text-danger">*</span> </Label>
                                                        <Input
                                                            name="nom_chauffeur"
                                                            value={data.nom_chauffeur}
                                                            onChange={changeHandler}
                                                            type="text"
                                                            className="form-control"
                                                        />
                                                        {erreur.nom_chauffeur && (
                                                            <span className="text-danger">{erreur.nom_chauffeur}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>No De Permis</Label>
                                                        <Input
                                                            placeholder="Entrer le numéro de permis"
                                                            name="num_permis"
                                                            value={data.num_permis}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.num_permis && (
                                                            <span className="text-danger">{erreur.num_permis}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Immatriculation <span className="text-danger">*</span></Label>
                                                        <Input
                                                            placeholder="Entrer l'immatriculation"
                                                            name="immatriculation"
                                                            value={data.immatriculation}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.immatriculation && (
                                                            <span className="text-danger">{erreur.immatriculation}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Destination <span className="text-danger">*</span></Label>
                                                        <Input
                                                            placeholder="Entrer la destination"
                                                            name="destination"
                                                            value={data.destination}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.destination && (
                                                            <span className="text-danger">{erreur.destination}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Téléphone <span className="text-danger">*</span></Label>
                                                        <Input
                                                            placeholder="Entrer le numéro de téléphone"
                                                            name="telephone"
                                                            value={data.telephone}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.telephone && (
                                                            <span className="text-danger">{erreur.telephone}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                        
                                    <Col xs="12" className="d-flex mt-3">
                                        <Btn color="info" className="me-2 w-100" disabled={isSubmitting} type="submit">
                                            Modifier
                                        </Btn>
                                        <Btn color="danger" className="ms-2 w-100" disabled={isSubmitting} onClick={handleCancel}>
                                            Annuler
                                        </Btn>
                                    </Col>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
}


export const AugmenterLeMontantPourCimaf = ({ isOpen, versement_id, toggle, onSuccess }: { isOpen: boolean; versement_id: number; toggle: () => void;  onSuccess: () => void; }) => {
    const Token = JSON.parse(localStorage.getItem("login")!);

    const [data, setData] = useState({
        num_paiement: '',
        date_paiement: '',
        montant: '',
        // id_paiement: '',
        id_versement: '',
    });

    const [justificatif, setJustificatif] = useState<File | null>(null);
    const [erreur, setErreur] = useState({
        num_paiement: '',
        date_paiement: '',
        montant: '',
        justificatif: '',
        // id_paiement: '',
        id_versement: '',
    });

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;

        const formatMontant = (valeur: string) => {
            // Supprime tout sauf les chiffres
            const montantNettoye = valeur.replace(/[^\d]/g, '');
            // Formate le montant avec des espaces tous les trois chiffres
            return montantNettoye.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        };

        // Si le champ modifié est le montant, appliquez le formatage
        const formattedValue = name === "montant" ? formatMontant(value) : value;

        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();

        // Création de l'objet FormData
        const formData = new FormData();
        formData.append("num_paiement", data.num_paiement);
        formData.append("date_paiement", data.date_paiement);
        formData.append('montant', String(data.montant))
        formData.append("id_versement", String(versement_id));

        if (justificatif) {
            formData.append("justificatif", justificatif);
        }

        axios.post(`${URL_API}/augmenter-le-montant-pour-cimaf`, formData, {
            headers: {
                Authorization: `Bearer ${Token}`,
                'Content-Type': 'multipart/form-data',
            }
        }).then(response => {

            if (response.data.success) {

                toast.success(response.data.success)
                setData({
                    num_paiement: '',
                    date_paiement: '',
                    montant: '',
                    // id_paiement: '',
                    id_versement: '',
                });
                setErreur({
                    num_paiement: '',
                    date_paiement: '',
                    montant: '',
                    justificatif: '',
                    // id_paiement: '',
                    id_versement: '',
                });
                setJustificatif(null);
                toggle();
                onSuccess();
            }

        }).catch(error => {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };
            console.log('   Error response:', err.response);
            if (err.response && err.response.data && err.response.data.message) {
                toast.info('Erreur de validation des données')
                const newErrors = err.response.data.message;
                setErreur(prevErrors => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }

        })
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Augmentation du montant du versement : {versement_id}</h4>
                                <form onSubmit={handleSubmitData}>
                                    <Row className="g-3">
                                        <Col md="12">
                                            <Label>No de paiement</Label>
                                            <Input
                                                className="form-control"
                                                name="num_paiement"
                                                type="text"
                                                placeholder="Nouveau Numéro de paiement"
                                                value={data.num_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.num_paiement && (
                                                <span className="text-danger">{erreur.num_paiement}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Nouvelle Date de Paiement</Label>
                                            <Input
                                                className="form-control"
                                                name="date_paiement"
                                                type="date"
                                                value={data.date_paiement}
                                                onChange={changeHandler}
                                            />
                                            {erreur.date_paiement && (
                                                <span className="text-danger">{erreur.date_paiement}</span>
                                            )}
                                        </Col>
                                        <Col md="12">
                                            <Label>Montant à payer</Label>
                                            <Input
                                                className="form-control"
                                                name="montant"
                                                type="text"
                                                placeholder="Nouveau Montant a augmenter"
                                                value={data.montant}
                                                onChange={changeHandler}
                                            />
                                            {erreur.montant && (
                                                <span className="text-danger">{erreur.montant}</span>
                                            )}
                                        </Col>
                                        {/* <Col md="12">
                                            <Label>Justificatif</Label>
                                            <Input
                                                className="form-control"
                                                name="justificatif"
                                                type="file"
                                                onChange={handleFileChange}
                                            />
                                            {erreur.justificatif && (
                                                <span className="text-danger">{erreur.justificatif}</span>
                                            )}
                                        </Col> */}
                                        <Col xs="12">
                                            <Btn color="info" className="me-2" type="submit">
                                                Soumettre
                                            </Btn>
                                            <Btn color="danger" className="mx-2" onClick={toggle}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};

export const DispatchementDeProquit = ({ isOpen, toggle, }: { isOpen: boolean; toggle: () => void; }) => {
    const [data, setData] = useState({
        pdv: '',
    });


    const Token = JSON.parse(localStorage.getItem("login")!);
    const [clients, setClients] = useState<clientsInterface[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const { cart } = useAppSelector((state: { cartData: any; }) => state.cartData);
    const dispatch = useAppDispatch();
    const clearPanier = () => dispatch(clearCart());
    

    const [erreur, setErreur] = useState({
        pdv: '',
    });
    const navigate = useNavigate()

    useEffect(() => {
        const fetchUsers = async () => {
            axios.get(`${URL_API}/pdv/get`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status == 200) {
                    setClients(response.data.clients);
                }

            }).catch(error => {
                if (error.status === 400) {
                    toast.info("Aucun PDV n'est enrégistré");
                }

                if (error.status === 500) {
                    toast.warning(error.response.data.message);
                }
            })
        };

        fetchUsers();

    },[]);

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        
        if(value === 'ajouter'){
            navigate('/points-de-ventes')
        }else{
            // const formattedValue = name === "vente" || name == 'transport' ? formatMontant(value) : value;
            setData((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await axios.post(`${URL_API}/approvisionner-un-pdv`, {...data, cart}, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            
            setData({
                pdv: '',
            });
            setErreur({
                pdv: '',
            });
            toast.success("Aprovisionnement effectuer avec success");
            clearPanier();
            navigate('/points-de-ventes');
            toggle();
            
            
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };
            console.log(err)
            if (err.response?.data?.message) {
                toast.info('Erreur de validation des données');
                const newErrors = err.response.data.message;
                setErreur((prevErrors) => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }
        }
        setIsSubmitting(false);
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Selectionner le PDV a approvisionner</h4>
                                <form>
                                    <Row className="g-3">
                                        
                                        <Col sm='12'>
                                            <Input
                                                className="form-control"
                                                name="pdv"
                                                type="select"
                                                value={data.pdv}
                                                onChange={changeHandler}
                                                >
                                                <option value=''>Selectionner ici</option>
                                                {clients.map((item, index) => (
                                                    <option key={index} value={item.id}>{item.name}</option>
                                                ))}
                                                <option value='ajouter'>AJOUTER UN NOUVEAU PDV</option>
                                            </Input>
                                            {erreur.pdv && (
                                                <span className="text-danger">{erreur.pdv}</span>
                                            )}
                                        </Col>
                                        <Col sm='12' className="text-center mb-3">
                                            <Link to='/points-de-ventes' className="fw-bold fs-6"> <i className="fa fa-hand-o-right"></i> Ajouter un nouveau pdv ici <i className="fa fa-hand-o-left"></i> </Link>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs="12 mt-2 d-flex">
                                            <Btn color="info" className="me-2 w-100" disabled={isSubmitting} type="button" onClick={handleSubmitData}>
                                                { isSubmitting ? "En cours..." : "Aprovisionner" }
                                            </Btn>
                                            <Btn color="danger" className="w-100" onClick={toggle}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};

export const AffecterUneCommadeAUnClient = ({ isOpen, toggle, }: { isOpen: boolean; toggle: () => void; }) => {
    const [data, setData] = useState({
        pdv: '',
    });


    const Token = JSON.parse(localStorage.getItem("login")!);
    const [clients, setClients] = useState<clientsInterface[]>([]);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const { cart } = useAppSelector((state: { cartData: any; }) => state.cartData);
    const dispatch = useAppDispatch();
    const clearPanier = () => dispatch(clearCart());
    

    const [erreur, setErreur] = useState({
        pdv: '',
    });
    const navigate = useNavigate()

    useEffect(() => {
        const fetchUsers = async () => {
            axios.get(`${URL_API}/clients/get`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status == 200) {
                    setClients(response.data.clients);
                }

            }).catch(error => {
                if (error.status === 400) {
                    toast.info('Aucune client ne dispose de ce privilège');
                }

                if (error.status === 500) {
                    toast.warning(error.response.data.message);
                }
            })
        };

        fetchUsers();

    },[]);

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        
        if(value === 'ajouter'){
            navigate('/Clients')
        }else{
            // const formattedValue = name === "vente" || name == 'transport' ? formatMontant(value) : value;
            setData((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const handleSubmitData = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await axios.post(`${URL_API}/approvisionner-un-pdv`, {...data, cart}, {
                headers: {
                    Authorization: `Bearer ${Token}`,
                },
            });
            
            setData({
                pdv: '',
            });
            setErreur({
                pdv: '',
            });
            toast.success("Aprovisionnement effectuer avec success");
            clearPanier();
            navigate('/Clients');
            toggle();
            
            
        } catch (error) {
            const err = error as { response?: { data?: { message?: Record<string, string> } } };
            console.log(err)
            if (err.response?.data?.message) {
                toast.info('Erreur de validation des données');
                const newErrors = err.response.data.message;
                setErreur((prevErrors) => ({
                    ...prevErrors,
                    ...newErrors,
                }));
            }
        }
        setIsSubmitting(false);
    };

    return (
        <Modal fade backdrop="static" centered isOpen={isOpen} toggle={toggle}>
            <div className="modal-dialog m-0">
                <div className="modal-content">
                    <Col xl="12">
                        <Card className="social-profile text-start mb-0">
                            <CardBody>
                                <h4 className="mb-3">Selectionner le client</h4>
                                <form>
                                    <Row className="g-3">
                                        
                                        <Col sm='12'>
                                            <Input
                                                className="form-control"
                                                name="pdv"
                                                type="select"
                                                value={data.pdv}
                                                onChange={changeHandler}
                                                >
                                                <option value=''>Selectionner ici</option>
                                                {clients.map((item, index) => (
                                                    <option key={index} value={item.id}>{item.name}</option>
                                                ))}
                                                <option value='ajouter'>AJOUTER UN NOUVEAU CLIENT</option>
                                            </Input>
                                            {erreur.pdv && (
                                                <span className="text-danger">{erreur.pdv}</span>
                                            )}
                                        </Col>
                                        <Col sm='12' className="text-center mb-3">
                                            <Link to='/Clients' className="fw-bold fs-6"> <i className="fa fa-hand-o-right"></i> Ajouter un nouveau client ici <i className="fa fa-hand-o-left"></i> </Link>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col xs="12 mt-2 d-flex">
                                            <Btn color="info" className="me-2 w-100" disabled={isSubmitting} type="button" onClick={handleSubmitData}>
                                                { isSubmitting ? "En cours..." : "Affecter" }
                                            </Btn>
                                            <Btn color="danger" className="w-100" onClick={toggle}>
                                                Fermer
                                            </Btn>
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>
                    </Col>
                </div>
            </div>
        </Modal>
    );
};
